import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useDisplayAlias } from "../hub/hubLabel";

interface PageTitleContextValue {
  title: string | null;
  setTitle: (t: string | null) => void;
}

const PageTitleContext = createContext<PageTitleContextValue | undefined>(
  undefined
);

export const PageTitleProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const capitalizedCustomer = useDisplayAlias() || "Aeronet";

  const [title, setTitle] = useState<string | null>(null);

  useEffect(() => {
    const base = capitalizedCustomer;
    if (!title) {
      document.title = base;
    } else {
      document.title = `${base} - ${title}`;
    }
  }, [capitalizedCustomer, title]);

  const value = useMemo(
    () => ({
      title,
      setTitle,
    }),
    [title]
  );

  return (
    <PageTitleContext.Provider value={value}>
      {children}
    </PageTitleContext.Provider>
  );
};

export function usePageTitle() {
  const ctx = useContext(PageTitleContext);
  if (!ctx) throw new Error("usePageTitle must be used within PageTitleProvider");
  return ctx;
}
